import React from 'react';
import PropTypes from 'prop-types';
import { useWindowScroll } from 'react-use';

// Images
import HeaderLogoImage from '../../../assets/images/logo.svg';

// Atoms
import {
	HeaderWrapper, HeaderMenuLimitingWidthWrapper, HeaderLogo, LogoLink,
} from './Header.atoms';

// Molecules
import Menu from '../../Molecules/Menu/Menu';

const Header = (props) => {
	const { links, isSticky } = props;
	const { y } = useWindowScroll();
	return (
		<HeaderWrapper scrolled={y > 0} isSticky={isSticky}>
			<HeaderMenuLimitingWidthWrapper>
				<LogoLink href="/" to="/">
					<HeaderLogo src={HeaderLogoImage} alt="FatCat ArenaContext" />
				</LogoLink>
				<Menu links={links} />
			</HeaderMenuLimitingWidthWrapper>
		</HeaderWrapper>
	);
};

Header.defaultProps = {
	links: undefined,
	isSticky: false,
};

Header.propTypes = {
	links: PropTypes.arrayOf(PropTypes.shape({
		to: PropTypes.string,
		name: PropTypes.string,
	})),
	isSticky: PropTypes.bool,
};

export default Header;
